// export const apiBaseUrl = "http://localhost:5000";
export const apiBaseUrl = "https://analogx.seedx.live/API/public/index.php/api";
